import { AuctionAccessLogo, Body, Button, FlexBox, Headline, Line, dsColors } from '@Backlot-Cars/archie';
import { useTranslation } from 'next-i18next';

const NOT_STANDARD_COLORS = {
	background: '#F4F8FE',
};

const AuctionAccessLookupStart = ({ onStart }) => {
	const { t } = useTranslation(['signup']);
	const handleStart = () => onStart();
	const handleStartButtonClick = (event) => {
		event.stopPropagation();
		handleStart();
	};

	return (
		<FlexBox flexDirection="column" margin="0 auto" width="min(100%, 600px)" gap="xl">
			<Headline size="H2">{t('signup:auctionAccessLookup.start.heading')}</Headline>

			<FlexBox
				alignItems="center"
				background={NOT_STANDARD_COLORS.background}
				borderColor="brand"
				borderRadius="sm"
				borderWidth={1}
				onClick={handleStart}
				padding="md"
			>
				<AuctionAccessLogo />

				<FlexBox flex={1} flexDirection="column" margin={[0, 'md']} minWidth={0} justifyContent="space-between">
					<Body bold color={dsColors.colorBrand.primary} size="smaller">
						{t('signup:auctionAccessLookup.start.subTitle')}
					</Body>
					<Headline size="H5">{t('signup:auctionAccessLookup.start.title')}</Headline>
				</FlexBox>

				<Button type="button" variant="secondary" textWrap="nowrap" onClick={handleStartButtonClick}>
					{t('signup:auctionAccessLookup.start.action')}
				</Button>
			</FlexBox>

			<FlexBox alignItems="center" gap="sm" padding={['xs', 0]} width="100%">
				<Line margin="0" orientation="horizontal" width="100%" />
				<Body color="secondary" size="smaller">
					{t('signup:auctionAccessLookup.start.or', { defaultValue: 'OR' })}
				</Body>
				<Line margin="0" orientation="horizontal" width="100%" />
			</FlexBox>
		</FlexBox>
	);
};

export default AuctionAccessLookupStart;
